import * as React from 'react'
import { ActionIcon } from '@mantine/core'

// 社区行政村减灾能力
const SvgComponent = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 26"
    className="design-iconfont"
    width={width}
    height={height}
  >
    <defs>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="98.993%"
        id="0v6ccvg87__kgchz1aveb"
      >
        <stop stopColor="#FF856D" offset="0%" />
        <stop stopColor="#DD3131" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="0v6ccvg87__qhltjmif4a"
      >
        <stop stopColor="#FF9F9F" offset="0%" />
        <stop stopColor="#EE7676" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="0v6ccvg87__86nnbqzzyc"
      >
        <stop stopColor="#FFECEC" offset="0%" />
        <stop stopColor="#FFD5D5" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M10.759 1a9.698 9.698 0 0 1 6.898 2.874 9.82 9.82 0 0 1 2.86 6.946c0 2.385-1.506 5.3-3.329 7.873C14.858 21.98 11.923 25 10.758 25c-1.164 0-4.098-3.019-6.43-6.307C2.507 16.12 1 13.205 1 10.82a9.82 9.82 0 0 1 2.86-6.946A9.698 9.698 0 0 1 10.76 1Z"
        stroke="url(#0v6ccvg87__qhltjmif4a)"
        strokeWidth={2}
        fill="url(#0v6ccvg87__kgchz1aveb)"
      />
      <path
        d="M5.828 2.55a3.642 3.642 0 0 1 3.637 3.448l.005.194v4.006h1.275c.08 0 .148.052.172.125l.01.057v.729c0 .08-.052.149-.125.173l-.057.009H.91a.182.182 0 0 1-.173-.125l-.01-.057v-.729c0-.08.053-.148.125-.172l.058-.01h1.274V6.192A3.642 3.642 0 0 1 5.828 2.55Zm.344 1.875L4.316 6.59a.091.091 0 0 0 .07.15h1.156L5.325 8.25a.091.091 0 0 0 .158.072L7.34 6.159a.091.091 0 0 0-.07-.15H6.115l.216-1.513a.091.091 0 0 0-.158-.07Zm-5.12-1.62 1.263.728-.547.946-1.261-.728.546-.946Zm9.55 0 .547.945-1.262.729-.546-.946 1.261-.729ZM3.388.871l.728 1.262-.946.546L2.44 1.42l.947-.547Zm4.88 0 .945.545-.728 1.262-.946-.546L8.267.87ZM6.373.363v1.457H5.28V.364h1.093Z"
        fill="url(#0v6ccvg87__86nnbqzzyc)"
        transform="translate(4.931 4.931)"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

const Icon = (props) => {
  const {
    fill = '#0152D9',
    variant = 'transparent',
    size = 20,
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <SvgComponent width={width} height={height} color={fill} />
    </ActionIcon>
  )
}

export default Icon
